import React, { FC } from 'react';
import { MenuItem } from '@mui/material';
import { jobScheduleSelectOptions } from '@efacity/common';
import { FormInputTextProps, FormTextInput } from './FormTextInput';

export const JobPostingScheduleSelector: FC<FormInputTextProps> = ({ name, ...props }) => {
  return (
    <FormTextInput name={name} label="Job Schedule" select {...props}>
      {jobScheduleSelectOptions.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </FormTextInput>
  );
};
